/**
 * Bootstraps the backoffice React application.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppRouter } from "./app/AppRouter";
import "./styles/globals.css";

const rootElement = document.querySelector("#root");

if (!(rootElement instanceof HTMLElement)) {
  throw new Error("Backoffice root element was not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
